import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { EntityState } from '../../../entity/entity.reducer';
import { EntityTypes } from '../../../entity/entity-types';
import { createEntitiesSelector } from '../../../entity/entities.reducer';
import { createSymfonyTotalCountSelector } from '../../../symfony/list/selectors/list.selectors';
import { Entities } from '../../../entity/entities';
import { getDiagramListState } from '../common.reducer';
import { Diagram } from '../models/diagram';

const createState = (id: IdType) => createSelector(
  getDiagramListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateByContext = (id: IdType) => createListStateIdsSelector(createState(id));

export const createDiagramListData = (id: IdType) => createSelector(
  createStateByContext(id),
  createEntitiesSelector([
    EntityTypes.diagram,
    EntityTypes.diagramPart
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.diagram]], entities) as Diagram[]
);

export const createDiagramListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createDiagramListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createDiagramListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createDiagramListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createDiagramListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
